import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export var NoTranslate = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("span", {
        className: "notranslate",
        children: children
    });
};
